export const SMALL_ELEMENT_MAX_SIDE_PX = 40;
